export interface IPricingItem {
  id: number;
  name: string;
  price: number;
  lookupsTotal: number | "infinite";
  benefits: string[];
}

export const freeBenefits = ["Geolocation", "ASN", "BasicSupport"];
export const basicBenefits = [
  "Lookups",
  "Geolocation",
  "ASN",
  "Abuse",
  "RiskScores",
  "Company",
  "IpWhois",
  "IpIntel",
  "IpRanges",
  "VPNDetection",
  "TorDetection",
  "PrioritySupport",
];

export const pricingList: IPricingItem[] = [
  {
    id: 1,
    name: "Free",
    price: 0,
    lookupsTotal: "infinite",
    benefits: freeBenefits,
  },
  {
    id: 2,
    name: "Standard",
    price: 9.99,
    lookupsTotal: 200,
    benefits: basicBenefits,
  },
  {
    id: 3,
    name: "Advanced",
    price: 19.99,
    lookupsTotal: 1000,
    benefits: basicBenefits,
  },
  {
    id: 4,
    name: "Professional",
    price: 39.99,
    lookupsTotal: 3000,
    benefits: basicBenefits,
  },
  {
    id: 5,
    name: "Extreme",
    price: 49.99,
    lookupsTotal: 5000,
    benefits: basicBenefits,
  },
  {
    id: 12,
    name: "Business",
    price: 199,
    lookupsTotal: 25000,
    benefits: basicBenefits,
  },
  {
    id: 13,
    name: "Corporation",
    price: 499,
    lookupsTotal: 100000,
    benefits: basicBenefits,
  },
];